export default __webpack_public_path__ + "static/media/icon-livro-registro-especifico.0cfc5bbf.svg";